import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true, status: null, name: null });

  useEffect(() => {
    const orderId = params.get("order_id");
    if (!orderId) {
      setState({ loading: false, status: "ERROR", name: null });
      return;
    }
    axios
      .get(`${API}/orders/${orderId}/status`)
      .then(({ data }) => setState({ loading: false, status: data.status, name: data.customer_name }))
      .catch(() => setState({ loading: false, status: "ERROR", name: null }));
  }, [params]);

  const { loading, status, name } = state;
  const isPaid = status === "PAID";

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16" data-testid="payment-return-page">
      <div className="bg-white border border-brandgreen/15 rounded-3xl p-10 md:p-14 max-w-lg w-full text-center shadow-lg">
        {loading ? (
          <>
            <Loader2 className="w-14 h-14 text-brandgold mx-auto animate-spin" />
            <h1 className="text-2xl text-brandgreen-dark mt-6">भुगतान की स्थिति जाँची जा रही है...</h1>
          </>
        ) : isPaid ? (
          <>
            <div className="w-20 h-20 rounded-full bg-brandgreen/10 flex items-center justify-center mx-auto">
              <CheckCircle2 className="w-12 h-12 text-brandgreen" data-testid="payment-success-icon" />
            </div>
            <h1 className="text-3xl text-brandgreen-dark mt-6">भुगतान सफल!</h1>
            <p className="font-sans text-brandgreen/80 mt-3">
              {name ? `${name} जी, ` : ""}आपकी पुस्तक "शुद्ध दिनचर्या – सुख और स्वास्थ्य" के लिए धन्यवाद। आपकी प्रति जल्द ही आपके पते पर भेजी जाएगी।
            </p>
          </>
        ) : status === "PENDING_PAYMENT" || status === "ACTIVE" ? (
          <>
            <Clock className="w-16 h-16 text-brandgold mx-auto" />
            <h1 className="text-2xl text-brandgreen-dark mt-6">भुगतान प्रक्रिया में है</h1>
            <p className="font-sans text-brandgreen/80 mt-3">
              आपका भुगतान अभी संसाधित हो रहा है। कृपया कुछ समय बाद जाँचें।
            </p>
          </>
        ) : (
          <>
            <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center mx-auto">
              <XCircle className="w-12 h-12 text-destructive" data-testid="payment-failed-icon" />
            </div>
            <h1 className="text-2xl text-brandgreen-dark mt-6">भुगतान पूर्ण नहीं हुआ</h1>
            <p className="font-sans text-brandgreen/80 mt-3">
              आपका भुगतान सफल नहीं हो सका। कृपया पुनः प्रयास करें।
            </p>
          </>
        )}

        {!loading && (
          <Button
            onClick={() => navigate("/")}
            data-testid="back-home-button"
            className="mt-8 rounded-full bg-brandgold hover:bg-brandgold-hover text-brandgreen-dark font-sans font-bold px-10 py-6 hover:scale-105 transition-transform"
          >
            मुख्य पृष्ठ पर लौटें
          </Button>
        )}
      </div>
    </div>
  );
}
